import { TwilioEndpointsService } from "./twilio-endpoints.service";
import { DataRetrieverEndpointsService } from "./data-retriever-endpoints.service";
import { AppointmentsEndpointsService } from "./appointments-endpoints.service";

/**
 * Endpoints service:
 * @description Contains all of the different endpoints, divided by micro-services
 */
class EndpointsImpl {
	twilio = TwilioEndpointsService;
	dataRetriever = DataRetrieverEndpointsService;
	appointments = AppointmentsEndpointsService;
}
export const EndpointsService = new EndpointsImpl();
